import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggedUser } from 'src/app/services/authentication/authentication';
import { ApiModelStrategy, ModelStrategyTypes } from 'src/app/services/rest-api/rest-api';
import { UserService } from 'src/app/services/user/user.service';
import { CUSTOM_STRATEGY_GLOBAL_INDEX } from '../constants';
import SwiperCore, { FreeMode, Pagination, Navigation } from 'swiper';

SwiperCore.use([FreeMode, Pagination, Navigation]);

const sortStrategies = (a: ApiModelStrategy, b: ApiModelStrategy): number => {
  if (a.uiOrder && b.uiOrder) {
    return a.uiOrder - b.uiOrder;
  } else {
    return a.modelStrategyId - b.modelStrategyId;
  }
}

@Component({
  selector: 'libero-model-strategy-carousel',
  templateUrl: './model-strategy-carousel.component.html',
  styleUrls: ['./model-strategy-carousel.component.scss'],
  standalone: false
})
export class ModelStrategyCarouselComponent implements OnInit {
  @Input() public modelStrategies?: ApiModelStrategy[];
  @Input() public canCreateEfektika = false;

  public modelStrategiesForView = {
    portfolios: [] as ApiModelStrategy[],
    strategies: [] as ApiModelStrategy[],
    oks: [] as ApiModelStrategy[],
  }
  public get loggedUser(): LoggedUser {
    if(!this.userService.loggedUser || this.userService.loggedUser === null) {
      this.router.navigate(['/login']);
    }

    return this.userService.loggedUser!;
  }

  public constructor(
    private userService: UserService,
    private router: Router,
  ) { }

  public ngOnInit(): void {
    this.addStaticStrategy();
    this.splitAndSortStrategies();
  }


  private splitAndSortStrategies(): void {
    if(this.modelStrategies?.length) {
      this.modelStrategiesForView.portfolios =
        this.filterAndSortStrategies(ModelStrategyTypes.MODEL_PORTFOLIO);
      this.modelStrategiesForView.strategies =
        this.filterAndSortStrategies(ModelStrategyTypes.THEMATIC_STRATEGY);
      this.modelStrategiesForView.oks =
        this.filterAndSortStrategies(ModelStrategyTypes.OKS);
    }
  }

  private filterAndSortStrategies(type: ModelStrategyTypes): ApiModelStrategy[] {
    return this.modelStrategies?.filter(apiStrategy => apiStrategy.type === type).sort(sortStrategies) ?? [];
  }

  private addStaticStrategy(): void {
    if(!this.modelStrategies) {
      this.modelStrategies = [];
    }
    this.modelStrategies.unshift(CUSTOM_STRATEGY_GLOBAL_INDEX);
  }
}
